import type { TenantUserMapping } from "../../../../../packages/shared-types/src/index.js";

export interface GroupedIdentityMappingUser {
  userId: string;
  displayName: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  channels: string[];
  userId: string;
}

export function resolveIdentityMappingDisplayName(rule: TenantUserMapping): string {
  const full = [rule.firstName, rule.lastName].filter(Boolean).join(" ");
  return full || rule.displayName || rule.userId;
}

export function groupIdentityMappingsByUser(
  rules: TenantUserMapping[],
): GroupedIdentityMappingUser[] {
  const grouped = new Map<string, GroupedIdentityMappingUser>();
  for (const rule of rules) {
    const existing = grouped.get(rule.userId);
    if (existing) {
      if (!existing.channels.includes(rule.channel)) {
        existing.channels.push(rule.channel);
      }
      continue;
    }
    grouped.set(rule.userId, {
      userId: rule.userId,
      displayName: resolveIdentityMappingDisplayName(rule),
      firstName: rule.firstName,
      lastName: rule.lastName,
      email: rule.email,
      phone: rule.phone,
      channels: [rule.channel],
    });
  }
  return Array.from(grouped.values()).toSorted((left, right) =>
    left.displayName.localeCompare(right.displayName),
  );
}
